import AbstractFieldsValidator from 'components/helpers/validation/AbstractFieldsValidator';
import validateEmail from 'components/helpers/validation/validateEmail';
import validatePassword from 'components/helpers/validation/validatePassword';
import moment from 'moment';

export default function (fields, options) {
    return new DoctorFieldsValidator(fields, options).validate();
}

const MAX_NAME_LENGTH = 35;

class DoctorFieldsValidator extends AbstractFieldsValidator {
    doCheckForSingleValue() {
        const {
            firstName, lastName, middleName, gender,
            birthDate, specialties, languages,
            licenses, education, graduation, graduationYear, timezone, residency,
        } = this.fields;
        if (!firstName || !firstName.trim()) {
            this.addError('firstName', 'Please type first name');
        } else if (firstName.length >= MAX_NAME_LENGTH) {
            this.addError('firstName', `Max first name length is ${MAX_NAME_LENGTH}`);
        }
        if (!lastName || !lastName.trim()) {
            this.addError('lastName', 'Please type last name');
        } else if (lastName.length >= MAX_NAME_LENGTH) {
            this.addError('lastName', `Max last name length is ${MAX_NAME_LENGTH}`);
        }
        if (middleName && middleName.length >= MAX_NAME_LENGTH) {
            this.addError('middleName', `Max middle name length is ${MAX_NAME_LENGTH}`);
        }
        if (!gender) this.addError('gender', 'Please select gender');
        if (!birthDate || !birthDate.isValid()) {
            this.addError('birthDate', loc('birthDate-empty'));
        } else {
            const minDate = moment("01.01.1900", "DD.MM.YYYY");
            if (moment().isBefore(birthDate)) {
                this.addError('birthDate', loc('birthDate-max-invalid'))
            }
            if (minDate.isAfter(birthDate)) {
                this.addError('birthDate', loc('birthDate-min-invalid'))
            }
        }
        if (!graduation) this.addError('graduation', 'Please select degree');
        if (!languages || languages.length === 0) this.addError('languages', 'Please select at least one language');
        if (!education || !education.trim()) this.addError('education', 'Please type medical school');
        if (graduationYear > parseInt(moment().format('YYYY'))) this.addError('graduationYear', 'Please type a valid year of graduation');
        if (!residency) this.addError('residency', 'Please type residency or internship');
        if (!licenses || licenses.length === 0) this.addError('licenses', 'Please select at least one state');
        if (!timezone) {
            this.addError('timezone', 'Please select timezone');
        }

        if (!specialties || !specialties.length) {
            this.addError('specialties', 'Please, select at least one specialty');
        }

        const {
            password, confirmPassword, email
        } = this.fields;

        if (!email.trim()) this.addError('email', 'Please enter email');

        if (!validateEmail(email.trim())) this.addError('email', 'Please enter a valid email');

        const passwordError = validatePassword(password);
        if (passwordError) this.addError('password', passwordError);

        if (!confirmPassword.trim()) this.addError('confirmPassword', 'Please repeat your password');
    }

    doCheckForRelations() {
        const {password, confirmPassword} = this.fields;

        if (password !== confirmPassword) this.addError('confirmPassword', 'Passwords do not match');
    }
}



// WEBPACK FOOTER //
// ./src/components/Auth/Register/validateDoctorFields.js